// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e56dd17","453":"b4cfd79e","667":"1836dea8"}[chunkId] + ".chunk.js";
};